import script from "./page-heading.vue?vue&type=script&setup=true&lang=ts"
export * from "./page-heading.vue?vue&type=script&setup=true&lang=ts"

import "./page-heading.vue?vue&type=style&index=0&id=3660e9c3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3660e9c3"]])

export default __exports__